export const lightTheme = {
	background_01: '#FFFFFF',
	background_02: '#F4F4F4',
	background_03: '#000000',
	background_04: '#7A60FF',
	background_05: '#171717',
	background_06: '#F9F9F9',
	background_07: '#F4F4F4',
	background_08: '#0682F0',
	background_09: '#F5F5FF',
	background_10: '#FAFAFA',

	card_background_01: '#F4F4F4',
	card_background_02: '#FFFFFF',
	card_background_03: '#1B1A1D',
	card_background_04: '#101212',
	card_background_05: '#4658F9',
	card_background_06: '#EEEEEE',

	check_background_01: '#666666',
	check_background_02: '#C6C6C6',
	check_background_03: '#FFFFFF',

	modal_background_01: 'rgba(0, 0, 0, 0.5)',
	modal_background_02: '#FFFFFF',
	modal_background_03: 'rgba(0, 0, 0, 1)',

	img_background_01: '#FFFFFF',

	divider_background_01: '#1F2122',
	divider_background_02: '#EEEEEE',
	divider_background_03: '#FFFFFF',

	pinCode_background_01: '#DDDDDD',
	pinCode_background_02: '#0682F0',
	pinCode_background_03: '#F94946',
	pinCode_background_04: '#DEF750',
	pinCode_background_05: '#333333',

	text_01: '#000000',
	text_02: '#666666',
	text_03: '#999999',
	text_04: '#000000',
	text_05: '#141414',
	text_06: '#5F6467',
	text_07: '#F94946',
	text_08: '#7A60FF',
	text_09: '#777777',
	text_10: '#797979',
	text_11: '#FF000F',
	text_12: '#121022',
	text_13: '#797979',
	text_14: '#070707',
	text_15: '#333333',
	text_16: '#555555',
	text_17: '#DD4B70',
	text_18: '#0682F0',
	text_19: '#A8AFF0',

	error_text_01: '#F94946',

	button_01: '#DCDCDC',
	button_02: '#7A60FF',
	button_03: '#CCCCCC',
	button_04: '#FFFFFF',
	button_05: '#CCCCCC',
	button_06: '#999999',
	button_07: '#0682F0',
	button_08: '#101212',

	border_01: '#F94946',
	border_02: '#ffffff',
	border_03: '#7A60FF',
	border_04: '#E4E1DF',
	border_05: '#999999',
	border_06: '#DCDCDC',
	border_07: '#0682F0',
	border_08: '#404345',
	border_09: '#3D3D3D',
	border_10: '#EEEEEE',
	border_11: '#C7C7C7',

	accent_lime: '#15C1A0',
	background_normal: '#FFFFFF',
	background_alternative: 'rgba(0, 0, 0, 0.5)',
	fill_alternative: '#DCDCDC',
	fill_disable: '#D7D7DE',
	fill_neutral: '#EFEFEF',
	fill_normal: '#F4F4F4',
	label_alternative: '#777777',
	label_disable: '#8D93C0',
	label_normal: '#070707',
	label_strong: '#000000',
	line_alternative: '#CCCCCC',
	line_neutral: '#E4E1DF',
	line_normal: '#AAAAAA',
	primary_alternative: '#EFF1FF',
	primary_disable: '#888b9b66',
	primary_normal: '#5d70F9',
	primary_normal_disable: '#5D6FF980',
	primary_strong: '#2C44ED',
	static_black: '#000000',
	static_white: '#FFFFFF',
	status_destrective: '#f94946',
	qr_img_fill_01: '#000000',
}

export const darkTheme = {
	background_01: '#000000',
	background_02: '#1B1A1D',
	background_03: '#000000',
	background_04: '#7A60FF',
	background_05: '#171717',
	background_06: '#F9F9F9',
	background_07: '#101212',
	background_08: '#0682F0',
	background_09: '#474953',
	background_10: '#101212',

	card_background_01: '#1F2122',
	card_background_02: '#FFFFFF',
	card_background_03: '#171717',
	card_background_04: '#101212',
	card_background_05: '#4658F9',
	card_background_06: '#101212',

	check_background_01: '#666666',
	check_background_02: '#C6C6C6',
	check_background_03: '#FFFFFF',

	modal_background_01: 'rgba(255, 255, 255, 0.5)',
	modal_background_02: '#000000',
	modal_background_03: 'rgba(255, 255, 255, 1)',

	img_background_01: '#FFFFFF',

	divider_background_01: '#EEEEEE',
	divider_background_02: '#1F2122',
	divider_background_03: '#2E3133',

	pinCode_background_01: '#DDDDDD',
	pinCode_background_02: '#0682F0',
	pinCode_background_03: '#F94946',
	pinCode_background_04: '#DEF750',
	pinCode_background_05: '#333333',

	text_01: '#FFFFFF',
	text_02: '#666666',
	text_03: '#999999',
	text_04: '#000000',
	text_05: '#CCCCCC',
	text_06: '#5F6467',
	text_07: '#F94946',
	text_08: '#7A60FF',
	text_09: '#777777',
	text_10: '#CCCCCC',
	text_11: '#FF000F',
	text_12: '#121022',
	text_13: '#797979',
	text_14: '#E4E4E4',
	text_15: '#333333',
	text_16: '#555555',
	text_17: '#DD4B70',
	text_18: '#0682F0',
	text_19: '#A8AFF0',

	error_text_01: '#F94946',

	button_01: '#4A484E',
	button_02: '#7A60FF',
	button_03: '#1F2122',
	button_04: '#FFFFFF',
	button_05: '#CCCCCC',
	button_06: '#999999',
	button_07: '#0682F0',
	button_08: '#101212',

	border_01: '#F94946',
	border_02: '#ffffff',
	border_03: '#7A60FF',
	border_04: '#2E3133',
	border_05: '#999999',
	border_06: '#dcdcdc',
	border_07: '#0682F0',
	border_08: '#404345',
	border_09: '#3d3d3d',
	border_10: '#EEEEEE',
	border_11: '#c7c7c7',

	accent_lime: '#15c1a0',
	background_normal: '#000000',
	background_alternative: 'rgba(0, 0, 0, 0.5)',
	fill_alternative: '#4a484e',
	fill_disable: '#272728',
	fill_neutral: '#0f1312',
	fill_normal: '#1b1a1d',
	label_alternative: '#888888',
	label_disable: '#EEEEEE80',
	label_normal: '#F8F8F8',
	label_strong: '#FFFFFF',
	line_alternative: '#666666',
	line_neutral: '#2E3133',
	line_normal: '#333333',
	primary_alternative: '#EFF1FF',
	primary_disable: '#6a74be4d',
	primary_normal: '#0682f0',
	primary_normal_disable: '#0682EF80',
	primary_strong: '#4352e5',
	static_black: '#000000',
	static_white: '#FFFFFF',
	status_destrective: '#f94946',
	qr_img_fill_01: '#000000',
}

export type Theme = typeof lightTheme
